import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const SESSION_STORAGE_KEY = 'i18nextLng';

/**
 * Custom language detector backed by sessionStorage.
 *
 * To switch language from the browser console:
 *   sessionStorage.setItem('i18nextLng', 'ja');
 *   location.reload();
 */
const sessionStorageDetector = {
  type: 'languageDetector',
  init: () => {},
  detect: () => {
    try {
      const stored = sessionStorage.getItem(SESSION_STORAGE_KEY);
      if (stored) return stored;
    } catch {
      // sessionStorage might not be available
    }
    return 'en';
  },
  cacheUserLanguage: lng => {
    try {
      sessionStorage.setItem(SESSION_STORAGE_KEY, lng);
    } catch {
      // sessionStorage might not be available
    }
  },
};

i18n
  .use(HttpBackend)
  .use(sessionStorageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [
      'common',
      'auth',
      'containers',
      'error',
      'interview_container',
      'interview_problem',
      'modal',
      'project_container',
      'practice_tests',
    ],

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },

    returnNull: false,
    returnEmptyString: false,
  });

export default i18n;
